<template lang="pug">
.typology(v-if="berData")
  .data
    .ber.info
      .info-label {{ $t('selections.berTypologyInfo.berNumber') }}
      .info-value {{ berData.berDetails?.berNumber }}
    .address.info 
      .info-label {{ $t('selections.berTypologyInfo.address') }}
      .info-value  {{ typylogyAddress }}
    .ber-rating.info 
      .info-label {{ $t('selections.berTypologyInfo.berRating') }}
      .info-value 
        RatingBox.rating-box(:value="berData.berDetails?.berRating")
    .details.info 
      .info-label {{ $t('selections.berTypologyInfo.details') }}
      .info-value  {{ berData.typology?.description }}
      .info-message
        a(@click="emitHouseForm") {{ $t('selections.berTypologyInfo.detailsWrong') }}
  
  
  </template>
<script lang="ts">
import { defineComponent } from "vue";
import { PropType, computed } from "vue";
import { GetTypologyByBerResponse, SeaiPartialBerAddress } from "@/types";
import RatingBox from "@/components/result/rating/RatingBox.vue";
import { LayoutEvent, emit } from "@/helpers";

export default defineComponent({
  components: {
    RatingBox,
  },
  props: {
    berData: {
      type: Object as PropType<GetTypologyByBerResponse>,
      required: true,
    },
  },
  setup(props) {
    const typylogyAddress = computed(() =>
      toAddressText(props.berData.berDetails?.address)
    );

    function toAddressText(address?: SeaiPartialBerAddress) {
      if (!address) return "";
      return Object.keys(address)
        .map((x) => ((address as unknown) as Record<string, string>)[x])
        .filter((x) => !!x)
        .join(", ");
    }

    function emitHouseForm() {
      emit(LayoutEvent.ShowHouseInfoForm, true)
    }

    return {
      typylogyAddress,
      emitHouseForm,
    };
  },
});
</script>
<style scoped lang="scss">
.typology {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  .data {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .info {
      display: flex;
      flex-direction: column;

      .info-label {
        font-weight: 600;
      }

      .info-message {
        font-size: 0.8rem;
        padding-top: 0.2rem;
        a {
          text-decoration: underline;
          color: $secondary-color;
          cursor: pointer;
        }
      }

      .rating-box {
        padding: 0;
      }
    }
  }
}
</style>
